import React, { Component } from 'react';

import { connect } from 'react-redux';

import AccountInformationCard from './AccountInformationCard';
import DefaultCompanyCard from './DefaultCompanyCard';
import UpdatePasswordCard from './UpdatePasswordCard';

import classes from './MyAccount.module.css';

import * as CompanyInfoActions from '../../actions/companyInfoActions';
import * as CoreActions from '../../actions/coreActions';

class MyAccount extends Component {
    async componentDidMount() {
        const {
            fetchCompanyContractorTypes,
            fetchDefaultCompany
        } = this.props;

        await fetchCompanyContractorTypes();
        await fetchDefaultCompany();
    }

    async componentDidUpdate(prevProps) {
        let { currentUser, fetchDefaultCompany } = this.props;

        if (currentUser !== prevProps.currentUser) {
            await fetchDefaultCompany();
        }
    }

    render() {
        return (
            <div className={classes.MyAccount}>
                <AccountInformationCard />
                <DefaultCompanyCard
                    companyInfo={this.props.companyInfo}
                />
                <UpdatePasswordCard
                    signOut={this.props.signOut}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentUser: state.currentUser
    };
};

const mapDispatchToProps = {
    ...CompanyInfoActions,
    ...CoreActions
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAccount);
